import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ProcessInstances } from '../model/bpmn/process-instance';

@Injectable({
    providedIn: 'root'
  })
  export class ProcessInstanceService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    findCurrentChildrenOrSuperByRequestInstanceId(processInstancesId) 
    {
        return this._restClientService.load<ProcessInstances>('bpmn/process-instances/find-current-child-or-super-by-requestinstanceid/'+processInstancesId);
    }
    
  
}